import { useEffect } from "react";

const App = () => {
  useEffect(() => {
    const hashPath = window.location.hash.replace(/^#/, "");
    const isServer = hashPath === "/server" || window.location.pathname.endsWith("/server");
    window.location.replace(
      isServer ? "https://shahrukhqureshi.com/server" : "https://shahrukhqureshi.com"
    );
  }, []);

  return null;
};

export default App;
